<template>
    <div>
        <div class="flex recommend">
            <div class="flex-3">
                <el-form ref="form" :model="form" label-width="150px">
                    <el-form-item label="请输入淘宝号：">
                        <el-input
                            type="textarea"
                            wrap="off"
                            v-model="form.keyword"
                            :rows="5"
                            :placeholder="`请在这里输入你需要的批量的查询的淘宝号\n一行一个淘宝号，最多支持5个。\n普通用户只能一次查询一个，vip用户支持5个淘宝号`"
                        ></el-input>
                    </el-form-item>
                    <el-form-item>
                        <span class="fc-theme fs-12">通过官方千人千面算法机制模拟计算获得用户搜索的推荐词</span>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" @click="onSubmit">提交查询</el-button>
                        <el-button v-if="showDownload" type="primary" @click="excelExport">下载查询结果</el-button>
                    </el-form-item>
                </el-form>
                <div class="marginT-20 flex flex-wrap">
                    <div class="item" v-for="(item, index) in result" :key="index">
                        <div>•淘宝号：{{index}}</div>
                        <div v-if="result[index].length > 0">
                            <div class="key" v-for="(keyword, i) in result[index]" :key="i">{{keyword}}</div>
                        </div>
                        <div v-else class="text-center">暂无推荐词</div>
                    </div>
                </div>
            </div>
            <div class="flex-2 right">
                <h3 class="fs-24 marginB-10">淘宝号搜索词推荐</h3>
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <el-tabs v-model="activeTip">
                            <el-tab-pane label="淘宝号搜索词推荐" name="first"></el-tab-pane>
                        </el-tabs>
                    </div>
                    <div class="fs-14" v-if="activeTip == 'first'">
                        <div class="title fc-theme fs-16">淘宝号搜索词推荐</div>
                        <div class="content fs-12 fc-666">
                            1、通过实时查询官方对指定淘宝号推荐的搜索词，获取到淘宝相关的标签。
                            <br>2、判断淘宝号是否有搜索的标签词，选择合适的淘宝号做活动，提升权重较高。
                        </div>
                        <div class="title fc-theme fs-16">使用场景</div>
                        <div class="content fs-12 fc-666">
                            1、挑选出所需要标签的淘宝号，选择适合的淘宝号做单能快速的提高商品的权重值，同样的操作流程选择质量好的账号达到的效果比一般旺旺号补好几单还好。
                            <br>2、结合淘宝千人千面流量相关的规则，查询符合商品标签的淘宝号做引流，使得引流更加精准提高商品的成交率，选择近期对店铺商品标签感兴趣的淘宝号做推送，提高自然成交单数。
                        </div>
                        <div class="title fc-theme fs-16">消费说明</div>
                        <div class="content fs-12 fc-666">
                            1、一个搜索词查询一次非会员{{price.point}}点券/个，会员原价40点券/个，限时优惠{{price.vip_point}}点券/个，点击<span class="fc-blue point" @click="$router.push('/vip')">开通会员</span>。
                            <br>2、淘宝号不存在，系统也会给出推荐词，查询一次扣一次费用。查询成功才会扣取点券，查询失败不扣取点券。
                        </div>
                        <div class="content fc-theme">API接口微信号 {{getkfWx()}}</div>
                    </div>
                </el-card>
            </div>
        </div>
        <div class="query-record">
            <el-card class="box-card flex-1 marginT-20">
                <div slot="header" class="flex flex-between">
                    <span class="fw-bold fc-333">查询记录<span style="font-size: 12px; color: #f00; padding-left: 6px;">(查询记录数据仅保存90天)</span></span>
                </div>
                <div>
                    <div class="table">
                        <el-table :data="tableData" border>
                            <el-table-column prop="status" align="center" label="淘宝号">
                                <template slot-scope="scope">{{ scope.row.invoke_params.account}}</template>
                            </el-table-column>
                            <el-table-column prop="created_at" label="提交时间">
                                <template slot-scope="scope">{{ (scope.row.invoke_time * 1000) | dateFormatUtils}}</template>
                            </el-table-column>
                            <el-table-column prop="status" align="center" width="100" label="查询状态">
                                <template slot-scope="scope">{{ scope.row.result_code == 0 ? '成功' : '失败'}}</template>
                            </el-table-column>
                            <el-table-column prop="result_message" align="center" label="记录备注"></el-table-column>
                            <el-table-column align="center" width="100"
                                prop="money_type" label="消耗点数">
                                <template
                                    slot-scope="scope">{{scope.row.invoke_paid_point}}</template>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div class="pages marginT-20 text-center">
                        <el-pagination @current-change="handleCurrentChange"
                            :current-page="page" :page-size="5"
                            layout="total, prev, pager, next, jumper"
                            :total="total"></el-pagination>
                    </div>
                </div>
            </el-card>
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import mixin from '../../mixin/pagination'
import XLSX from 'xlsx'
export default {
    computed: {
        ...mapState(['userData'])
    },
    mixins: [mixin],
    props: {
        price: {
            type: Object,
            default: {}
        },
    },
    data() {
        return {
            showDownload: false,
            activeTip: 'first',
            form: {
                keyword: ''
            },
            result: {},
            searchForm: {
                cate: 'tool',
                method: 'usertag',
                psize: 5
            },
            tableData: [],
            tableUrl: '/tool/accounts/api-record'
        }
    },
    methods: {
        excelExport() {
            let exportJson = []
            for (const key in this.result) {
                exportJson.push({'淘宝号': key, '推荐词': this.result[key].join(',')})
            }
            if (exportJson.length == 0) {
                this.$message.error('未找到查询结果')
                return
            }
            let sheet = XLSX.utils.json_to_sheet(exportJson)
            this.openDownloadDialog(this.sheet2blob(sheet),'淘宝号搜索词推荐结果.xlsx')
        },
        // 将一个sheet转成最终的excel文件的blob对象，然后利用URL.createObjectURL下载
        sheet2blob(sheet, sheetName) {
            sheetName = sheetName || 'sheet1';
            var workbook = {
                SheetNames: [sheetName],
                Sheets: {}
            };
            workbook.Sheets[sheetName] = sheet; // 生成excel的配置项

            var wopts = {
                bookType: 'xlsx', // 要生成的文件类型
                bookSST: false, // 是否生成Shared String Table，官方解释是，如果开启生成速度会下降，但在低版本IOS设备上有更好的兼容性
                type: 'binary'
            };
            var wbout = XLSX.write(workbook, wopts);
            var blob = new Blob([s2ab(wbout)], {
                type: "application/octet-stream"
            }); // 字符串转ArrayBuffer
            function s2ab(s) {
                var buf = new ArrayBuffer(s.length);
                var view = new Uint8Array(buf);
                for (var i = 0; i != s.length; ++i) view[i] = s.charCodeAt(i) & 0xFF;
                return buf;
            }
            return blob;
        },
        openDownloadDialog(url, saveName) {
            if (typeof url == 'object' && url instanceof Blob) {
                url = URL.createObjectURL(url); // 创建blob地址
            }
            var aLink = document.createElement('a');
            aLink.href = url;
            aLink.download = saveName || ''; // HTML5新增的属性，指定保存文件名，可以不要后缀，注意，file:///模式下不会生效
            var event;
            if (window.MouseEvent) event = new MouseEvent('click');
            else {
                event = document.createEvent('MouseEvents');
                event.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
            }
            aLink.dispatchEvent(event);
        },
        async onSubmit() {
            if (!localStorage.token) {
                this.$bus.emit('openLogin')
                return
            }
            window.checkDiscountPackage("usertag")
            // this.$alert('由于淘宝版本变动，导致查询的结果不稳定，建议不要使用，能使用后平台会进行通知', '提示', {
            //     confirmButtonText: '确定'
            // });
            const textList = this.form.keyword.replace(/ /g, '').split('\n').filter(x => x)
            if (textList.length > 1) {
                if (this.userData.is_vip) {
                    if (textList.length > 5) {
                        this.$message.error('一次只能查询5个搜索词')
                        return
                    } else {
                        let loading = this.$loading({
                            lock: true,
                            text: '提交中',
                            spinner: 'el-icon-loading',
                            background: 'rgba(255, 255, 255, 0.5)'
                        })
                        await Promise.all(
                            textList.map(async (item, index) => {
                                await this.getData(item)
                            })
                        )
                        loading.close()
                        this.$store.dispatch('upDateUser')
                    }
                } else {
                    this.$message.error('普通用户一次只能查询一个搜索词')
                    return
                }
            } else {
                if (textList.length == 0) {
                    this.$message.error('请输入淘宝号')
                    return
                }
                let loading = this.$loading({
                    lock: true,
                    text: '提交中',
                    spinner: 'el-icon-loading',
                    background: 'rgba(255, 255, 255, 0.5)'
                })
                await this.getData(textList[0])
                loading.close()
            }
            this.init()
        },
        async getData(keyword) {
            try {
                const data = await this.$fetch('/api/proxy/web/usertag', {account: keyword})

                if (data && data.code === 0) {
                    // this.$set(this.result, keyword, data.data.tags ? data.data.tags.split(',') : [])
                    this.$set(this.result, keyword, data.data.tags || [])
                    this.showDownload = true
                    // this.result[keyword] =
                }
            } catch(e) {
                console.log({e})
            }
        }
    },
    mounted () {
        this.init();
    },
}
</script>

<style lang="scss" scoped>
.right {
    margin-left: 30px;
    .title {
        margin-top: 5px;
    }
}
.recommend {
    .item {
        flex-basis: 48%;
        padding: 4px;
        margin: 10px 0px;
        border-radius: 6px;
        /* background: #f5f5f5; */
        /* box-shadow: 0 2px 12px 0 rgba(0,0,0,.1); */
        .key {
            display: inline-block;
            background: #ddd;
            color: #333;
            margin: 4px;
            padding: 3px 10px;
            height: 18px;
            line-height: 18px;
            border-radius: 9px;
        }
    }
    ::v-deep textarea {
        resize: none;
    }
}
</style>
<style lang="scss">
.recommend {
    .el-card__header {
        padding-bottom: 0;
    }
    .el-tabs__header {
        margin-bottom: 0;
    }
    .el-tabs__nav-wrap::after {
        height: 0;
    }
}
</style>
